import { Component, h } from '@stencil/core';

@Component({
  tag: 'spw-table-head',
  styleUrl: 'spw-table-head.scss',
  shadow: true,
})
export class SpwTableHead {
  render() {
    return (
      <thead part="thead">
        <slot />
      </thead>
    );
  }
}
